import { render } from "./widgetWrapperScpm.vue?vue&type=template&id=7b10590c&scoped=true"
import script from "./widgetWrapperScpm.vue?vue&type=script&lang=js"
export * from "./widgetWrapperScpm.vue?vue&type=script&lang=js"

import "./widgetWrapperScpm.vue?vue&type=style&index=0&id=7b10590c&lang=scss"
import "./widgetWrapperScpm.vue?vue&type=style&index=1&id=7b10590c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b10590c"],['__file',"src/components/scpm/widgets/common/widgetWrapperScpm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7b10590c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7b10590c', __exports__)) {
    api.reload('7b10590c', __exports__)
  }
  
  module.hot.accept("./widgetWrapperScpm.vue?vue&type=template&id=7b10590c&scoped=true", () => {
    api.rerender('7b10590c', render)
  })

}


export default __exports__